/**
 * StrategyEditorModal
 *
 * Thin overlay wrapper around StrategyEditorPanel — the matrix-based replacement
 * for StrategyWizardDialog. Used for full create / edit on the basket page and
 * from the Schedule-page gear icon. The panel itself is layout-agnostic; this
 * just supplies the modal chrome (backdrop, header, scroll, close).
 */

import React from 'react';
import { X } from 'lucide-react';
import StrategyEditorPanel from './StrategyEditorPanel';
import FocusedDialog from '../ui/FocusedDialog';

interface StrategyEditorModalProps {
  basketId: string;
  editingStrategy?: any;
  onDone: (result: any) => void;
  onCancel: () => void;
}

const StrategyEditorModal: React.FC<StrategyEditorModalProps> = ({
  basketId,
  editingStrategy,
  onDone,
  onCancel,
}) => (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-start sm:items-center justify-center p-2 sm:p-4 z-50">
    <FocusedDialog
      ariaLabel={editingStrategy ? 'Edit strategy' : 'New strategy'}
      className="w-full max-w-6xl h-full sm:h-[95vh] flex flex-col bg-white dark:bg-gray-900 rounded-none sm:rounded-2xl shadow-2xl overflow-hidden"
    >
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700 shrink-0">
        <h2 className="text-base font-semibold text-gray-900 dark:text-white">
          {editingStrategy ? 'Edit Strategy' : 'New Strategy'}
        </h2>
        <button
          type="button"
          onClick={onCancel}
          className="p-1.5 rounded-md text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto">
        <StrategyEditorPanel
          basketId={basketId}
          editingStrategy={editingStrategy}
          onDone={onDone}
          onCancel={onCancel}
        />
      </div>
    </FocusedDialog>
  </div>
);

export default StrategyEditorModal;
